import type { WriteRejection } from "@estelle/domain";

/**
 * Turn one `WriteRejection` into a sentence someone can act on.
 *
 * Same shape as `describeRejection` in `contacts/screens/ContactTypes.tsx`,
 * kept as its own copy rather than a shared import — module directories stay
 * self-contained. The `switch` with no `default` means a sixth rejection
 * kind added to `@estelle/domain` fails this file at compile time instead of
 * silently falling through to a generic "something went wrong."
 */
export function describeRejection(rejection: WriteRejection): string {
  switch (rejection.kind) {
    case "blocked":
    case "channel_rejected":
      return rejection.message;
    case "conflict":
      return `${rejection.message} (it changed at ${rejection.currentUpdatedAt})`;
    case "forbidden":
      return `${rejection.message} (requires ${rejection.permission})`;
    case "invalid":
      return rejection.fields
        ? `${rejection.message} ${Object.entries(rejection.fields)
            .map(([field, problem]) => `${field}: ${problem}`)
            .join("; ")}`
        : rejection.message;
  }
}
